export const hours = [
  {
    id: 0,
    hour: '00:00'
  },
  {
    id: 1,
    hour: '01:00'
  },
  {
    id: 2,
    hour: '02:00'
  },
  {
    id: 3,
    hour: '03:00'
  },
  {
    id: 4,
    hour: '04:00'
  },
  {
    id: 5,
    hour: '05:00'
  },
  {
    id: 6,
    hour: '06:00'
  },
  {
    id: 7,
    hour: '07:00'
  },
  {
    id: 8,
    hour: '08:00'
  },
  {
    id: 9,
    hour: '09:00'
  },
  {
    id: 10,
    hour: '10:00'
  },
  {
    id: 11,
    hour: '11:00'
  },
  {
    id: 12,
    hour: '12:00'
  },
  {
    id: 13,
    hour: '13:00'
  },
  {
    id: 14,
    hour: '14:00'
  },
  {
    id: 15,
    hour: '15:00'
  },
  {
    id: 16,
    hour: '16:00'
  },
  {
    id: 17,
    hour: '17:00'
  },
  {
    id: 18,
    hour: '18:00'
  },
  {
    id: 19,
    hour: '19:00'
  },
  {
    id: 20,
    hour: '20:00'
  },
  {
    id: 21,
    hour: '21:00'
  },
  {
    id: 22,
    hour: '22:00'
  },
  {
    id: 23,
    hour: '23:00'
  }
];

export const halfHours = [
  {
    id: 0,
    hour: '00:00'
  },
  {
    id: 1,
    hour: '00:30'
  },
  {
    id: 2,
    hour: '01:00'
  },
  {
    id: 3,
    hour: '01:30'
  },
  {
    id: 4,
    hour: '02:00'
  },
  {
    id: 5,
    hour: '02:30'
  },
  {
    id: 6,
    hour: '03:00'
  },
  {
    id: 7,
    hour: '03:30'
  },
  {
    id: 8,
    hour: '04:00'
  },
  {
    id: 9,
    hour: '04:30'
  },
  {
    id: 10,
    hour: '05:00'
  },
  {
    id: 11,
    hour: '05:30'
  },
  {
    id: 12,
    hour: '06:00'
  },
  {
    id: 13,
    hour: '06:30'
  },
  {
    id: 14,
    hour: '07:00'
  },
  {
    id: 15,
    hour: '07:30'
  },
  {
    id: 16,
    hour: '08:00'
  },
  {
    id: 17,
    hour: '08:30'
  },
  {
    id: 18,
    hour: '09:00'
  },
  {
    id: 19,
    hour: '09:30'
  },
  {
    id: 20,
    hour: '10:00'
  },
  {
    id: 21,
    hour: '10:30'
  },
  {
    id: 22,
    hour: '11:00'
  },
  {
    id: 23,
    hour: '11:30'
  },
  {
    id: 24,
    hour: '12:00'
  },
  {
    id: 25,
    hour: '12:30'
  },
  {
    id: 26,
    hour: '13:00'
  },
  {
    id: 27,
    hour: '13:30'
  },
  {
    id: 28,
    hour: '14:00'
  },
  {
    id: 29,
    hour: '14:30'
  },
  {
    id: 30,
    hour: '15:00'
  },
  {
    id: 31,
    hour: '15:30'
  },
  {
    id: 32,
    hour: '16:00'
  },
  {
    id: 33,
    hour: '16:30'
  },
  {
    id: 34,
    hour: '17:00'
  },
  {
    id: 35,
    hour: '17:30'
  },
  {
    id: 36,
    hour: '18:00'
  },
  {
    id: 37,
    hour: '18:30'
  },
  {
    id: 38,
    hour: '19:00'
  },
  {
    id: 39,
    hour: '19:30'
  },
  {
    id: 40,
    hour: '20:00'
  },
  {
    id: 41,
    hour: '20:30'
  },
  {
    id: 42,
    hour: '21:00'
  },
  {
    id: 43,
    hour: '21:30'
  },
  {
    id: 44,
    hour: '22:00'
  },
  {
    id: 45,
    hour: '22:30'
  },
  {
    id: 46,
    hour: '23:00'
  },
  {
    id: 47,
    hour: '23:30'
  }
];
